import React, { useEffect,useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { connect,useSelector, useDispatch } from 'react-redux';
import { MESSAGES } from '../../constants/constants.js';

import FundsService from '../../../services/funds-service.js';
import { initialFormData, initialErrors, fieldValidation  } from '../../common/helper/form-constants.js';
import LoaderOverlay from './../../common/helper/loader.component.js';
import { toast } from 'react-toastify';

const Transfer = (props) => {
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({ ...initialErrors });
    const [formDataMerchant, setFormDataMerchant] = useState({toMerchant: '', amountMerchant: '', remarkMerchant: ''})
    const [formDataWithdraw, setFormDataWithdraw] = useState({toAgentWithdraw: '', amountMerchantWithdraw: '', remarkAgent: ''})
    const userData = useSelector(state => state.authReducer);

    
    const validateField = (fieldName, value) => {
      const errorMessage = fieldValidation(fieldName, value);
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
      return errorMessage
    };
    
   
    const handleChangeMerchant = (e) => {
      const { name, value } = e.target;
      setFormDataMerchant((prevData) => ({ ...prevData, [name]: value }));
      validateField(name, value);
    };
    const fundMerchant = (e) => {
      e.preventDefault();
      let hasErrors;
      Object.keys(formDataMerchant).forEach(fieldName => {
        const error = validateField(fieldName, formDataMerchant[fieldName]);
        if (error) {
            hasErrors = true;
        }
    });
  
    if(!hasErrors) {
      setLoading(true);
      const data = {
        transfer_amount: formDataMerchant.amountMerchant,
        funder_type:'DISTRIBUTOR',
        funder_id:formDataMerchant.toMerchant
      }
      FundsService.depositFund(data)
        .then(response => {
          props.onSave();
          toast.success(MESSAGES.FUND_DEPOSIT);
          setLoading(false);
        })
        .catch(error => {
          const errorMessage = error.response.data
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
          setLoading(false);
         
        });
      }
    }
  
    const handleChangeWithdraw = (e) => {
      const { name, value } = e.target;
      setFormDataWithdraw((prevData) => ({ ...prevData, [name]: value }));
      validateField(name, value);
    };
    const withdrawMerchant = (e) => {
      e.preventDefault();

      let hasErrors;
      Object.keys(formDataWithdraw).forEach(fieldName => {
        const error = validateField(fieldName, formDataWithdraw[fieldName]);
        console.log(error);
        if (error) {
            hasErrors = true;
        }
    });
  
    if(!hasErrors) {
      setLoading(true);
      const data = {
        transfer_amount: formDataWithdraw.amountMerchantWithdraw,
        funder_type:'DISTRIBUTOR',
        funder_id:formDataMerchant.toMerchant
      }
      FundsService.withdrawFund(data)
        .then(response => {
          toast.success(MESSAGES.FUND_WITHDRAW);
          props.onSave();
          setLoading(false);
        })
        .catch(error => {
          const errorMessage = error.response.data
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
          setLoading(false);
         
        });
      }
    }
  
  
    
      useEffect(() => {
        setFormDataMerchant({
          toMerchant: props.rowData.user_id,
          name: props.rowData.full_name,
          amountMerchant: '', 
          remarkMerchant: ''
        })
      }, []);
    return (
      <>
        <LoaderOverlay loading={loading} />
       <Modal  {...props}>
        <Modal.Header closeButton>
          <Modal.Title> Funds</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="container-fluid px-4">
        {/* <h4 className="updatename updatename2" style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Funds</h4> */}
        <div className="container" style={{backgroundColor: 'white'}}>
          <nav>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <button className="nav-link active tbbtn" id="nav-home1-tab" data-bs-toggle="tab" data-bs-target="#nav-home1" type="button" role="tab" aria-controls="nav-home" aria-selected="true">Distributor Fund</button>
              <button className="nav-link tbbtn" id="nav-profile1-tab" data-bs-toggle="tab" data-bs-target="#nav-profile1" type="button" role="tab" aria-controls="nav-profile" aria-selected="false" onclick="myFunction()" tabIndex={-1}>Distributor Withdraw</button>
            </div>
          </nav>
          <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px'}}>
            <div className="tab-pane fade show active" id="nav-home1" role="tabpanel" aria-labelledby="nav-home1-tab">
            <form method="post" onSubmit={fundMerchant}>
              <div className="panel panel-default">
                <div className="panel-body" style={{padding: '0px'}}>
                  <div className="col-md-12" style={{padding: 0}}>
                    <div className="col-md-12" style={{padding: '0px', paddingRight: '30px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label className="required" htmlFor="Transaction">FROM</label>
                        <select style={{color: '#74788d'}} className="pull_accounts" name="Pull_account" id="pull_account" disabled>
                          <option value="XXXXX-POOL-ACCOUNT-XXXXXX">{userData.user.data.role.role_code == 'DADMIN' ? userData.user.data.full_name : "XXXXX-POOL-ACCOUNT-XXXXXX"}</option>
                        </select> 
                        
                      </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label className="required" htmlFor="to">TO</label>
                        <div className="select-search-container"><div className="select-search-value">

<p>{formDataMerchant.name}</p>
</div>
</div>
                        <span id="error_to_accounts" className="text-danger" />
                      </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label className="required" htmlFor="confirm_password">AMOUNT</label>
                        <input type="number"className={`form-control ${errors.amountMerchant ? 'is-invalid' : ''}`}  onChange={handleChangeMerchant} id="to_amounts" placeholder="Enter Your Amount" name="amountMerchant"/>
                        {errors.amountMerchant && <div className="invalid-feedback">{errors.amountMerchant}</div>}
                      </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="confirm_password">REMARK</label>
                        <input type="text" className="form-control nhjgf" id="profile_conpass" placeholder="Enter Remark" onChange={handleChangeMerchant} name ="remarkMerchant"/>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div align="left">
                    <button type="submit" name="btn_chngepass" id="btn_merchantsfunds" className="btn ddfg sebtn">Submit</button>
                  </div>
                  <br />
                </div>
              </div>
              </form>
            </div>
            <div className="tab-pane fade" id="nav-profile1" role="tabpanel" aria-labelledby="nav-profile1-tab">
            <form method="post" onSubmit={withdrawMerchant}>
              <div className="panel panel-default">
                <div className="panel-body" style={{padding: '0px'}}>
                  <div className="col-md-12" style={{padding: 0}}>
                    <div className="col-md-12" style={{padding: '0px', paddingRight: '30px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label className="required" htmlFor="to">FROM</label>
                        <div className="select-search-container"><div className="select-search-value">

                          <p>{formDataMerchant.name}</p>
                          </div>
                        </div>
                      </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label className="required" htmlFor="Transaction">TO</label>
                        <select style={{color: '#74788d'}} className="pull_accounts" name="Pull_account" id="pull_accounts" disabled>
                          <option value="Pull Account">{userData.user.data.role.role_code == 'DADMIN' ? userData.user.data.full_name : "XXXXX-POOL-ACCOUNT-XXXXXX"}</option>
                        </select>
                        <span id="error_pull_accounts" className="text-danger" />
                      </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label className="required" htmlFor="confirm_password">AMOUNT</label>
                        <input type="number"className={`form-control ${errors.amountMerchantWithdraw ? 'is-invalid' : ''}`}  onChange={handleChangeWithdraw} id="to_amounts" placeholder="Enter Your Amount" name="amountMerchantWithdraw"/>
                        {errors.amountMerchantWithdraw && <div className="invalid-feedback">{errors.amountMerchantWithdraw}</div>}
                      </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label htmlFor="confirm_password">REMARK</label>
                        <input type="text" className="form-control nhjgf" id="profile_conpass" placeholder="Enter Remark" onChange={handleChangeWithdraw} name ="remarkMerchant"/>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div align="left">
                    <button type="submit" name="btn_chngepass" id="btn_merchantswithdraw" className="btn ddfg sebtn">Submit</button>
                  </div>
                  <br />
                </div>
              </div>
              </form>
            </div>
          </div>
        </div>
      </div>


            
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.onHide}>
            Close
          </Button>
          {/* <Button variant="primary" onClick={props.onSave}>
            sumbit
          </Button> */}
        </Modal.Footer>
      </Modal>
      </>
    );
  }
  


  export default Transfer;



